import { useQuery } from "@tanstack/react-query";

import { AnalyticsStatsCardWithSeparator } from "components/analytics/display-card-with-separator";
import { AnalyticsStatsCardPlaceholderWithSeparator } from "components/analytics/placeholder-with-separator";
import { jobKeys } from "components/job/queries";
import { fetchInProgressJobsCount } from "components/timesheet/dashboard/jobs-coordinating/api";
import { Separator } from "ui/components/separator";

export function InProgressJobsCard() {
  const { data, isLoading } = useQuery({
    queryKey: jobKeys.inProgressCount(),
    queryFn: fetchInProgressJobsCount,
  });

  if (isLoading) return <AnalyticsStatsCardPlaceholderWithSeparator />;
  return <AnalyticsStatsCardWithSeparator label="In Progress" value={data} />;
}
